import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSelectedItems',
  standalone: true,
})
export class RemoveSelectedItemsPipe implements PipeTransform {
  constructor() {}

  transform(value: any, selectedItems, isUseApiFilter): any {
    if (!isUseApiFilter) return value;
    else {
      value = value.filter(
        (item) => !selectedItems.some((el) => el.id === item.id)
      );
      return value;
    }
  }
}
